import React from 'react';
import util from "../../util/tools";
import './index.css';
import Icon from '../../../common/images/deafult_head.png'
import Arrow from '../../../common/images/arrow_r.png'
import Header from "../common/Header";
import commonTools from "../../../common/util/util";
import ActivityPopup from '../common/ActivityPopup'

export default class Home extends React.Component {
    constructor() {
        super();
        this.state = {
            curTitle: "个人中心",
            userInfo:{
                user_money: {}
            },
            src:Icon,
            showPopup: false,
            popupId: null,
            activityUrl: '',
            activityId: ''
        };
    }

    componentDidMount() {
        document.title = this.state.curTitle;
        util.ajax({
            url: "/zh/user/userInfo",
            isUser: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data;
                    this.setState({
                        userInfo: data
                    })
                    sessionStorage.setItem('wechat_id',data.wechat_id)
                }
            }
        });
        this.checkPopup()
    }

    defaultHead(){
        this.setState({
            src: Icon
        })
    }

    goRoute(router){
        this.props.history.push(`${router}`)
    }

    // 判断是否有活动弹窗
    checkPopup() {
        const date = new Date()
        const fullYear = date.getFullYear()
        const month = date.getMonth()
        const day = date.getDate()
        const fullDate = `${fullYear}-${month+1}-${day}`
        const oldDate = localStorage.popupDate4
        util.ajax({
            url: '/zh/activity/activitypopup',
            data:{
                popup_id: 4
            },
            callback: res => {
                // console.log(res)
                if (res.result.status.code == 0 && res.result.data.length) {
                    const data = res.result.data[0]
                    this.setState({
                        popupId: data.temp_id,
                        activityUrl: data.activity_url,
                        activityId: data.id
                    })
                    if (!oldDate) {
                        this.setState({
                            showPopup: true
                        })
                        localStorage.popupDate4 = fullDate
                    } else if (oldDate && fullDate != oldDate ) {
                        this.setState({
                            showPopup: true
                        })
                        localStorage.popupDate4 = fullDate
                    } else {
                        this.setState({
                            showPopup: false
                        })
                    }
                }
            }
        })
    }

    // 关闭弹窗
    closePopup = () => {
        this.setState({
            showPopup: false
        })
    }

    render() {
        return (
            <div className='mine'>
                <Header />
                <div className='mes'>
                    <img className='mes_l' src={!!this.state.userInfo.headimgurl?this.state.userInfo.headimgurl:this.state.src} onError={()=>this.defaultHead()}/>
                    <div className='mes_r'>
                        <div className='mes_r_name'>
                            <span>{!!this.state.userInfo.headimgurl?this.state.userInfo.nickname:'读书人'}</span>
                            {
                               !!this.state.userInfo.member_info && !!this.state.userInfo.member_info.is_member==1 &&
                                    [
                                        <img src={require('../../../common/images/crown.png')} className='mes_r_name_crown' key={'a1'}/>,
                                        <span style={{fontSize:'0.28rem',color:'#FFB103',marginLeft:'2px'}} key={'a2'}>VIP会员</span>
                                    ]
                            }
                        </div>
                        <span className='mes_r_id'>您的账号ID:{this.state.userInfo.user_id} </span>
                        {
                            !!this.state.userInfo.member_info && !!this.state.userInfo.member_info.is_member==1 &&
                                <span className='mes_r_time'>{this.state.userInfo.member_info.end_time}到期</span>
                        }
                    </div>
                </div>
                <div className='series'>
                    <div className='series_single' onClick={()=>this.goRoute('/recharge')}>
                        <div className='series_single_l'>
                            <img className='series_single_l_icon' src={require('../../../common/images/cz.png')} alt=""/>
                            <span className='series_single_l_font'>充值</span>
                        </div>
                        <div className='series_single_r'>
                            <img className='series_single_r_arrow' src={Arrow} alt=""/>
                            <span className='series_single_r_font'>余额{this.state.userInfo.user_money.coin}金币 {parseInt(this.state.userInfo.user_money.hongbao)>0&&`+${this.state.userInfo.user_money.hongbao}红包`}</span>
                        </div>
                    </div>
                    <div className='series_single' onClick={()=>this.goRoute('/packet')}>
                        <div className='series_single_l'>
                            <img className='series_single_l_icon' src={require('../../../common/images/hb.png')} alt=""/>
                            <span className='series_single_l_font'>我的红包</span>
                        </div>
                        <div className='series_single_r'>
                            <img className='series_single_r_arrow' src={Arrow} alt=""/>
                        </div>
                    </div>
                    <div className='series_single' onClick={()=>this.goRoute('/recentlyread')}>
                        <div className='series_single_l'>
                            <img className='series_single_l_icon' src={require('../../../common/images/zjyd.png')} alt=""/>
                            <span className='series_single_l_font'>最近阅读</span>
                        </div>
                        <div className='series_single_r'>
                            <img className='series_single_r_arrow' src={Arrow} alt=""/>
                        </div>
                    </div>
                    <div className='series_single' onClick={()=>this.goRoute('/feedback')}>
                        <div className='series_single_l'>
                            <img className='series_single_l_icon' src={require('../../../common/images/kf.png')} alt=""/>
                            <span className='series_single_l_font'>在线客服</span>
                        </div>
                        <div className='series_single_r'>
                            <img className='series_single_r_arrow' src={Arrow} alt=""/>
                        </div>
                    </div>
                    <div className='series_single' onClick={()=>this.goRoute('/wuliulist')}>
                        <div className='series_single_l'>
                            <img className='series_single_l_icon' src={require('../../../common/images/addressBg.png')} alt=""/>
                            <span className='series_single_l_font'>查看物流信息</span>
                        </div>
                        <div className='series_single_r'>
                            <img className='series_single_r_arrow' src={Arrow} alt=""/>
                        </div>
                    </div>
                    <div className='series_single' onClick={()=>this.goRoute('/rotaryList')}>
                        <div className='series_single_l'>
                            <img className='series_single_l_icon' src={require('../../../common/images/cj.png')} alt=""/>
                            <span className='series_single_l_font'>我的奖品</span>
                        </div>
                        <div className='series_single_r'>
                            <img className='series_single_r_arrow' src={Arrow} alt=""/>
                        </div>
                    </div>
                </div>
                {
                    this.state.showPopup &&
                    <ActivityPopup
                        popupId={this.state.popupId} activityUrl={this.state.activityUrl}
                        activityId={this.state.activityId} closePopup={this.closePopup}>
                    </ActivityPopup>
                }
            </div>
        );
    }
}